/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import loading from '../../assets/images/loading.gif'
import { ImgLoadingSpinner } from "./styles";

export const LoadingSpinner = ({ isLoading }) => {
  return (
    <React.Fragment>
      <ImgLoadingSpinner
        loadingContent={isLoading}
        src={loading}
      />
    </React.Fragment>
  )
}
